import { warn } from '../../../logger';
import { InternalElementFactoryOptions, SdkElement } from '../../../model';
import { recordEvent } from '../../../telemetry';
import { SDKError } from '../../error';
import {
  PaymentMethodSelectorElement,
  PaymentMethodSelectorElementOptions
} from './PaymentMethodSelectorElement';
import { parsePaymentMethodSelectorOptions } from './paymentMethodSelectorOptionsSchema';

export const createPaymentMethodSelectorElement = async (
  elementOptions: PaymentMethodSelectorElementOptions,
  commonOptions: InternalElementFactoryOptions
): Promise<SdkElement> => {
  await recordEvent('sdk_payment_method_selector_element_init_options', {
    payment_method_selector_element_options: { ...elementOptions },
    elements_options: commonOptions
  });

  const {
    errors,
    warnings,
    options: validatedOptions,
    initialOptions
  } = parsePaymentMethodSelectorOptions(elementOptions);

  if (errors) {
    throw new SDKError(
      'invalidPaymentMethodSelectorElementOptions',
      'Invalid Payment Method Selector Element options provided.',
      errors
    );
  }

  if (warnings) {
    warn('invalidPaymentMethodSelectorElementOptions', warnings);
  }

  await recordEvent('sdk_payment_method_selector_element_options_validated', {
    payment_method_selector_element_warnings: warnings,
    payment_method_selector_element_options: initialOptions,
    elements_options: commonOptions
  });

  return PaymentMethodSelectorElement({ ...validatedOptions, ...commonOptions });
};
